import React from 'react';
import { Home, Heart, BookOpen, Compass, ExternalLink } from 'lucide-react';

const Navigation = ({ currentPage, onNavigate }) => {
  const navItems = [
    { id: 'home', label: 'Daily Wisdom', icon: Home },
    { id: 'resonance', label: 'Resonance', icon: Heart },
    { id: 'origins', label: 'The Library', icon: BookOpen },
    { id: 'explore', label: 'Explore', icon: Compass }
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-dark-slate/95 backdrop-blur-sm border-b border-cinnabar-red/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div 
            className="flex items-center cursor-pointer group"
            onClick={() => onNavigate('home')}
          >
            <span className="text-2xl font-serif text-porcelain-white group-hover:text-cinnabar-red transition-colors">
              Wisdom Nexus
            </span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1">
            {navItems.map((item) => {
              const Icon = item.icon;
              const isActive = currentPage === item.id;
              return (
                <button
                  key={item.id}
                  onClick={() => onNavigate(item.id)}
                  className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-all ${
                    isActive
                      ? 'bg-cinnabar-red text-porcelain-white'
                      : 'text-porcelain-white/70 hover:text-porcelain-white hover:bg-porcelain-white/10'
                  }`}
                >
                  <Icon size={18} />
                  <span className="text-sm font-medium">{item.label}</span>
                </button>
              );
            })}

            {/* Network Link */}
            <a
              href="https://chinesename.shop"
              target="_blank"
              rel="noopener noreferrer"
              className="ml-2 flex items-center space-x-2 px-4 py-2 rounded-lg border border-amber-200/20 bg-amber-500/5 text-amber-200/90 hover:bg-amber-500/10 hover:border-amber-200/30 hover:text-amber-200 transition-colors"
              title="Get a Chinese Name"
            >
              <ExternalLink size={18} />
              <span className="text-sm font-medium">Get a Chinese Name</span>
            </a>
          </div>

          {/* Mobile Navigation */}
          <div className="md:hidden flex items-center space-x-2">
            {navItems.map((item) => {
              const Icon = item.icon;
              const isActive = currentPage === item.id;
              return (
                <button
                  key={item.id}
                  onClick={() => onNavigate(item.id)}
                  className={`p-2 rounded-lg transition-all ${
                    isActive
                      ? 'bg-cinnabar-red text-porcelain-white'
                      : 'text-porcelain-white/70 hover:text-porcelain-white hover:bg-porcelain-white/10'
                  }`}
                  title={item.label}
                >
                  <Icon size={20} />
                </button>
              );
            })}

            <a
              href="https://chinesename.shop"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 rounded-lg border border-amber-200/20 bg-amber-500/5 text-amber-200/90 hover:bg-amber-500/10 hover:border-amber-200/30 transition-colors"
              title="Get a Chinese Name"
              aria-label="Get a Chinese Name (opens in a new tab)"
            >
              <ExternalLink size={20} />
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
